import SEO from "../components/SEO";
import seoData from "../seoData";
import BreadcrumbSchema from "../components/BreadcrumbSchema";
import { About } from "../components/about";
import JsonData from "../data/data.json";

const AboutPage = () => (
  <>
    {/* SEO Meta */}
    <SEO {...seoData.about} />
    <BreadcrumbSchema
        items={[
            { name: "Home", url: "/" },
            { name: "About", url: "/about" },
        ]}
    />
    <About data={JsonData.About} />
  </>
);

export default AboutPage;
